<div class="photos-grid-modal" *ngIf="photos.length">
  <div *ngFor="let item of photos; trackBy: trackByPhotoId" class="photo-tile">
    <div class="photo-item">
      <button
        type="button"
        class="photo-item-button"
        aria-label="Otevřít foto"
        (mousedown)="stopNestedPointer($event)"
        (click)="onPhotoClick(item, $event)"
      >
        <img [src]="photoSrc(item)" [alt]="item.id ?? 'Náhled'" (error)="onImageError($event, item)" />
      </button>
      <div class="photo-actions" *ngIf="showActions" (mousedown)="stopNestedPointer($event)">
        <app-download-icon-button
          ariaLabel="Stáhnout fotku"
          title="Stáhnout"
          (onClick)="onDownload(item, $event)"
        ></app-download-icon-button>
        <app-delete-icon-button
          *ngIf="canDeleteItem(item)"
          variant="danger"
          ariaLabel="Smazat"
          title="Smazat"
          [loading]="deletingId === item.id"
          [disabled]="!!deletingId"
          (onClick)="onDelete(item, $event)"
        ></app-delete-icon-button>
      </div>
    </div>
    <p *ngIf="item.caption" class="photo-caption">{{ item.caption }}</p>
  </div>
</div>
